

export class SolicitudRecorridosDTO {
  id: any;
  solicitudId: any;
  // solicitud: Solicitud;
  vcLugarSalida: any;
  vcLugarDestino: any;
  dtHoraSalida: any;
  dtHoraRecogida: any;
  dtHoraRegreso: any;
  dtHoraSalidaString: any;
  dtHoraRecogidaString: any;
  dtHoraRegresoString: any;
  btTieneRecorridoAdicional: any = false;
}